
import { components, rgb } from "./color"

export default function palette(from, to, count)
{
    const c1 = components(from);
    const c2 = components(to);

    console.log(from, c1, to, c2);

    const palette = new Array(count);

    const step = 1 / count;

    const rDelta = c2.r - c1.r;
    const gDelta = c2.g - c1.g;
    const bDelta = c2.b - c1.b;

    for (let i=0; i < count ; i++)
    {
        const intensity = (i * step);

        const r = ((c1.r + rDelta * intensity) * 255)|0;
        const g = ((c1.g + gDelta * intensity) * 255)|0;
        const b = ((c1.b + bDelta * intensity) * 255)|0;

        palette[i] = rgb(r,g,b);
    }

    return palette;
}



// WEBPACK FOOTER //
// ./src/util/palette.js